<div class="channel-config">
  <div class="channel-config__header">
    <h2 class="channel-config__title">{{ 'notifications.channelConfigs.title' | translate }}</h2>
    <p class="channel-config__description">{{ 'notifications.channelConfigs.description' | translate }}</p>
  </div>

  @if (isLoading()) {
    <div class="channel-config__loading" role="status">
      <span zagIcon="hourglass_empty" class="channel-config__loading-icon"></span>
      <span>{{ 'common.loading' | translate }}</span>
    </div>
  } @else {
    <!-- Matrix table -->
    <div class="channel-config__matrix-wrap">
      <table class="channel-config__matrix" role="grid">
        <thead>
          <tr>
            <th class="channel-config__event-col" scope="col">Event</th>
            @for (channel of channels; track channel) {
              <th class="channel-config__channel-col" scope="col">
                {{ 'notifications.channels.' + channel | translate }}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (eventType of eventTypes; track eventType) {
            <tr class="channel-config__row">
              <td class="channel-config__event-cell">{{ eventType }}</td>
              @for (channel of channels; track channel) {
                <td class="channel-config__toggle-cell">
                  <button
                    type="button"
                    class="channel-config__toggle"
                    [class.channel-config__toggle--on]="isEnabled(eventType, channel)"
                    [attr.aria-label]="('notifications.channels.' + channel | translate) + ' — ' + eventType"
                    [attr.aria-checked]="isEnabled(eventType, channel)"
                    role="switch"
                    (click)="toggleConfig(eventType, channel)"
                  >
                    <span class="channel-config__toggle-thumb"></span>
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Save bar -->
    <div class="channel-config__footer">
      @if (saveSuccess()) {
        <span class="channel-config__status channel-config__status--success">
          <span zagIcon="check_circle"></span>
          {{ 'notifications.channelConfigs.saveSuccess' | translate }}
        </span>
      }
      @if (saveError()) {
        <span class="channel-config__status channel-config__status--error">
          <span zagIcon="error_outline"></span>
          {{ 'notifications.channelConfigs.saveError' | translate }}
        </span>
      }
      <button type="button" class="channel-config__save-btn" [disabled]="isSaving() || !isDirty()" (click)="saveConfigs()">
        @if (isSaving()) {
          <span zagIcon="hourglass_empty"></span>
        } @else {
          <span zagIcon="save"></span>
        }
        {{ 'common.save' | translate }}
      </button>
    </div>
  }
</div>
